import { render, staticRenderFns } from "./v-right-card2.vue?vue&type=template&id=3e28c9cc&scoped=true"
import script from "./v-right-card2.vue?vue&type=script&lang=js"
export * from "./v-right-card2.vue?vue&type=script&lang=js"
import style0 from "./v-right-card2.vue?vue&type=style&index=0&id=3e28c9cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e28c9cc",
  null
  
)

export default component.exports